/**
 * Return milliseconds between two date
 *
 * @param a
 * @param b
 */
export const timeBetween = (a: Date, b: Date): number => {
  return a.getTime() - b.getTime()
}

export const msToMinute = (value: number) => value / (1000 * 60)
